import React from 'react';
import { Helmet } from 'react-helmet-async';

export function SEO({ title, description, canonical, openGraph = {}, twitter = {}, jsonLd = [] }) {
  const og = {
    title,
    description,
    type: 'website',
    url: canonical,
    image: '/assets/images/og-default.png',
    ...openGraph
  };
  const tw = {
    card: 'summary_large_image',
    title,
    description,
    image: '/assets/images/og-default.png',
    ...twitter
  };
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {/* Open Graph */}
      <meta property="og:title" content={og.title} />
      <meta property="og:description" content={og.description} />
      {og.type && <meta property="og:type" content={og.type} />}
      {og.url && <meta property="og:url" content={og.url} />}
      {og.image && <meta property="og:image" content={og.image} />}
      {/* Twitter */}
      <meta name="twitter:card" content={tw.card} />
      <meta name="twitter:title" content={tw.title} />
      <meta name="twitter:description" content={tw.description} />
      {tw.image && <meta name="twitter:image" content={tw.image} />}
      {/* JSON-LD */}
      {jsonLd.map((obj, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(obj) }} />
      ))}
    </Helmet>
  );
}

// JSON-LD builders
export const buildLocalBusinessJsonLd = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Rite HVAC Services',
  image: '/assets/images/og-default.png',
  '@id': 'https://www.ritehvacservices.com/',
  url: 'https://www.ritehvacservices.com/',
  telephone: '+1-812-555-0168',
  email: 'info@ritehvacservices.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '123 HVAC Drive',
    addressLocality: 'Bloomington',
    addressRegion: 'IN',
    postalCode: '47401',
    addressCountry: 'US'
  },
  areaServed: ['Bloomington IN', 'Ellettsville', 'Bedford', 'Martinsville', 'Spencer'],
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
    opens: '00:00',
    closes: '23:59'
  }]
});

export const buildServiceJsonLd = (serviceName, url) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: serviceName,
  areaServed: ['Bloomington IN','Ellettsville','Bedford','Martinsville','Spencer'],
  provider: {
    '@type': 'LocalBusiness',
    name: 'Rite HVAC Services',
    url: 'https://www.ritehvacservices.com/'
  },
  url
});

export const buildArticleJsonLd = (post) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: post.title,
  author: { '@type': 'Person', name: post.author || 'Rite HVAC Team' },
  datePublished: post.date,
  image: [post.featuredImage || '/assets/images/og-default.png'],
  mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://www.ritehvacservices.com/blog/' + post.slug }
});
